<template>
  <div class="shop-menu-members-only-wall" @click.stop>
    <div class="wrapper" :class="{ taller: init }">
      <div class="notification">
        <div class="mb">
          <p><i class="fa fa-user-lock fa-2x" /></p>
          <p class="subtitle">Members Only</p>
          <!-- <p class="has-text-left">
          Contact the shop to see how you can become a member!
        </p>
        <p class="has-text-right">
          <span
            class="button has-text-info"
            @click="callPhoneNumber(business.data.phone_number)"
          >
            Call the Shop &nbsp;<i class="fa fa-chevron-right fa-lg" />
          </span>
        </p> -->
          <p class="has-text-left">
            <i
              >Enter your email address to become a member. It's simple and
              free!</i
            >
          </p>
          <p v-if="joinBlurb" class="has-text-left" style="margin-top: 10px">
            <i>{{ joinBlurb }}</i>
          </p>
        </div>
        <div style="margin-bottom: 16px; margin-top: 10px">
          <input
            ref="email"
            class="input is-medium is-fullwidth"
            v-model="email"
            placeholder="Enter e-mail address"
          />
        </div>
        <div
          class="button is-medium is-fullwidth is-info"
          @click="submitMember"
        >
          <p>
            <span> Become a Member </span>
            <i class="is-pulled-right is-uppercase"> {{ this.$t("free") }} </i>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";

export default {
  name: "ShopMenuMembersOnlyWall",
  props: {
    business: Object,
    w: Object,
  },
  data() {
    return {
      init: false,
      email: null,
      loginCallback: "SHOP_MENU_MEMBER_ONLY_WALL_LOGIN_MEMBER_CALLBACK",
    };
  },
  computed: {
    membershipEmailWhitelist() {
      if (!this.w.data.membership) return null;
      return this.w.data.membership.email_whitelist;
    },
    joinBlurb() {
      if (!this.w.data.membership) return null;
      return this.w.data.membership.join_blurb;
    },
  },
  activated() {
    // this.updateRoles(false); // moved this to ShopPromosTab
  },
  mounted() {
    EventBus.$on(this.loginCallback, () => this.submitMember());
  },
  beforeDestroy() {
    EventBus.$off(this.loginCallback);
  },
  methods: {
    triggerWall() {
      this.init = false;
      setTimeout(() => (this.init = true), 1000);
    },
    focusEmail() {
      this.$refs.email.focus();
      // this.scrollToBottom();
      this.triggerEmailToast();
    },
    triggerEmailToast() {
      setTimeout(() => this.infoToast("Enter email address", "top"), 600);
    },
    validEmail() {
      if (!this.email) return false;
      if (this.email.length < 5) return false;
      if (!this.email.includes("@")) return false;
      return true;
    },
    submitMember() {
      var msg = "Please login first";
      if (!this.smsLoginOkay(msg, this.loginCallback)) return; //msg, this.loginCheckoutCallback
      if (!this.validEmail()) {
        this.focusEmail();
        return;
      }
      // check if there's an email whitelist first
      if (this.membershipEmailWhitelist) {
        this.checkEmailWhitelist();
      } else {
        this.createMemberRole(); // otherwise become a member
      }
    },
    checkEmailWhitelist() {
      if (this.membershipEmailWhitelist.includes(this.email)) {
        return this.createMemberRole(); // later check ID requirement before checkout
      } else {
        var msg = `I'm sorry, you're not on<br>the invite list for this shop.<br>We've added you to the waitlist.`;
        this.errorToast(msg, "top", 9000);
        var user = this.$store.getters.getNameAndNumber;
        var notify = `⛔️ ${this.email} ${user} not on whitelist for @ ${this.business.name}`;
        this.sendSuperuserNotification(notify);
        return;
      }
    },
    createMemberRole() {
      var data = {
        name: this.$store.getters.realName,
        email: this.email,
        // membership_number: this.membershipNumber,
        // notes: this.notes,
        // membership_length: this.expiry,
        // expiry_date: new Date(this.valueOf() + 24 * 60 * 60 * this.expiry),
      };
      var loader = this.loadingDots("blue");
      this.$store
        .dispatch("createRole", {
          phone_number: this.$store.getters.phoneNumber,
          business_id: this.w.business_id,
          workflow_id: this.w.id,
          workflow_name: this.w.name,
          role_type: "customer",
          role_name: "Member",
          data: data,
        })
        .then((res) => {
          this.console("createMemberRole success", res);
          this.updateRoles(false);
          var msg = "You're a member!";
          setTimeout(() => this.successToast(msg, "top"), 800);
          this.z += 1;
          this.log("member_joined_shop", this.business.name);
          var txt = `❤️ Member joined @ ${this.business.name} (${this.email})`;
          this.sendSuperuserNotification(txt);
          this.$emit("joined");
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.wrapper {
  position: absolute;
  bottom: 0;
  /* was 150px */
  height: calc(100vh - 245px);
  width: 100vw;
  max-width: 700px;
  overflow: hidden;
  /* background-color: #efe6395f; */
  background-color: #48cdf243;
  /* z-index: 1102; */
  z-index: 21;
  backdrop-filter: blur(5px);
}
.taller {
  height: calc(100vh - 200px);
  transition: height 0.3s ease;
}
.notification {
  margin: 30px 20px;
  padding: 20px;
  /* opacity: 0.85; */
  background-color: rgba(255, 255, 255, 0.8);
  /* box-shadow: 0 0 4px white; */
}
/* .notification p {
  margin-bottom: 8px;
} */
.mb p {
  margin-bottom: 8px;
}
.button p {
  width: 100%;
  text-align: left;
  display: table;
}
.button p > span {
  /* position: absolute;
  top: 50%;
  margin-top: -22px; */
  /* display: inline-block; */
  /* padding: 9px; */
  /* line-height: 45px; */
  display: table-cell;
  vertical-align: middle;
}
</style>